import * as tslib_1 from "tslib";
import { BUSINESS_CONST, BANK_INFO_CONST } from '../../constants/business.constants';
import { OpEnum } from '../../enums/op.enum';
import { DetailAccountModel, DetailRevolvingCreditModel, } from '../../models/abre-cuentas.model';
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { CaptureService } from '../capture/capture.service';
import { CopyService } from '../copies/copy.service';
import { CryptoVaultService } from '../external/crypto-vault/crypto-vault.service';
import { HelpersService } from '../helpers/helpers-onboarding.service';
import { FirmlyApprovedService } from '../firmly-approved/firmly-approved.service';
import { StringHelperService } from '../helpers/string-helper.service';
import { ValidationHelperService } from '../helpers/validation-helper.service';
import { ParametersService } from '../parameters/parameters.service';
import { ProductLoaderService } from '../product-loader/product-loader.service';
import { RequestService } from '../request/request-onboarding.service';
import { ChannelCommunicatorService } from '../communicator/channel-communicator/channel-communicator.service';
import { FormatNumberService } from '../../utils/format-number.service';
var PostValidateService = /** @class */ (function () {
    /**
     * Constructor de la clase
     *
     * *Class Contstructor.*
     *
     * Inicializa los métodos para los modelos
     *
     * *Initialize method for models*
     *
     * @param {AbreCuentasService} abreCuentasService
     * @param {CommunicatorService} communicatorService
     * @param {ValidationHelperService} validationHelperService
     * @param {RequestService} requestService
     */
    function PostValidateService(abreCuentasService, parametersService, validationHelperService, stringHelperService, requestService, productLoaderService, captureService, helperService, cryptoVaultService, copyService, firmlyApprovedService, channel, numberHelper, cipherService) {
        this.abreCuentasService = abreCuentasService;
        this.parametersService = parametersService;
        this.validationHelperService = validationHelperService;
        this.stringHelperService = stringHelperService;
        this.requestService = requestService;
        this.productLoaderService = productLoaderService;
        this.captureService = captureService;
        this.helperService = helperService;
        this.cryptoVaultService = cryptoVaultService;
        this.copyService = copyService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.channel = channel;
        this.numberHelper = numberHelper;
        this.cipherService = cipherService;
        this.priority = 1;
        /**
         * Variable contador de casos
         *
         * *get case count variable*
         *
         * @type {number}
         */
        this.getCaseCount = 0;
        /**
         * Variable contador de casos
         *
         * *get case count variable*
         *
         * @type {number}
         */
        this.callTimeOut = 0;
        this.creditRechargeUpInformation = [];
        this.liabilities = [];
    }
    /**
     * Función para cambiar los casos de la función
     *
     * *Switch function cases*
     *
     * @type {function}
     * @param {string} func
     * @returns {any}
     */
    PostValidateService.prototype.switchFunction = function (func) {
        switch (func) {
            case 'solicitationId':
                return this.solicitationId();
            case 'createClient':
                return this.createClient();
            case 'createContactInfoParticular':
                return this.createContactInfo('PARTICULAR');
            case 'createContactInfoLaboral':
                return this.createContactInfo('LABORAL');
            case 'prospectAddressesParticular':
                return this.prospectAddresses('PARTICULAR');
            case 'prospectAddressesLaboral':
                return this.prospectAddresses('LABORAL');
            case 'prospectAddressesCardSend':
                return this.prospectAddresses('CARD_SEND');
            case 'prospectAddresses':
                return this.prospectAddresses('DEFAULT');
            case 'createFinancials':
                return this.createFinancials();
            case 'foreignOperations':
                return this.foreignOperations();
            case 'createProducts':
                return this.createProducts();
            case 'performSolicitation':
                return this.performSolicitation();
            case 'getCase':
                return this.getCase();
            case 'getChannel':
                return this.channelCommunicator();
            case 'updateCaseAccountConfig':
                return this.updateCaseAccountConfig();
            case 'channelNotification':
                return this.getChannelNotification();
            default:
                break;
        }
    };
    /**
     * Función para obtener el código indentificador de la solicitud
     *
     * *Function that obtains solicitation id code*
     *
     * @type {function}
     * @returns {this.code}
     */
    PostValidateService.prototype.solicitationId = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var body;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = {
                            data: {
                                solicitation_type: '0003',
                            },
                        };
                        return [4 /*yield*/, this.requestService.createCaseSolicitationId(body).then(function (response) {
                                console.log('SolicitationID: ', response);
                                try {
                                    _this.abreCuentasService.setSolicitationId(response);
                                    _this.code = '200';
                                }
                                catch (error) {
                                    _this.code = '500';
                                }
                            }, function () {
                                _this.code = '500';
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    /**
     * Función para obtener notificación a canal
     *
     * *Function that obtains channel notification*
     *
     * @type {function}
     * @returns {this.code}
     */
    PostValidateService.prototype.channelCommunicator = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                setTimeout(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var _this = this;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.captureService
                                    .getChannelComunicator()
                                    .then(function (res) {
                                    _this.code = res;
                                })
                                    .catch(function () {
                                    _this.code = '500';
                                })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }, 30000);
                return [2 /*return*/, this.code];
            });
        });
    };
    /**
     * Función para envíar al servicio la información de contácto del usuario, retorna el código de éxito de la solicitud
     *
     * *Function that sends to the service user's contact information, returns solicitation success code*
     *
     * @type {function}
     * @param {string} type
     * @returns {this.code}
     */
    PostValidateService.prototype.createContactInfo = function (type) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.captureService.createContactInfo(type).then(function () {
                            try {
                                _this.code = '200';
                            }
                            catch (error) {
                                _this.code = '500';
                            }
                        }, function () {
                            return _this.code = '500';
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    /* istanbul ignore next */
    /**
     * Función para envíar al servicio la información básica del usuario (creación del cliente), retorna el código de éxito de la solicitud
     *
     * *Function that sends to the service user's contact information (client creation), returns solicitation success code*
     *
     * @type {function}
     * @returns {this.code}
     */
    PostValidateService.prototype.createClient = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.captureService.createClient().then(function () {
                            try {
                                _this.code = '200';
                            }
                            catch (error) {
                                console.log(error);
                                throw 500;
                            }
                        }, function () {
                            return _this.code = '500';
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    /* istanbul ignore next */
    /**
     * Función para envíar al servicio la información de dirección del usuario, retorna el código de éxito de la solicitud
     *
     * *Function that sends to the service user contact information depending on the case, returns solicitation success code*
     *
     * @type {function}
     * @returns {this.code}
     */
    PostValidateService.prototype.prospectAddresses = function (type) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.captureService.prospectAddresses(type).then(function () {
                            try {
                                _this.code = '200';
                            }
                            catch (error) {
                                _this.code = '500';
                            }
                        }, function () {
                            return _this.code = '500';
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    /* istanbul ignore next */
    /**
     * Función para envíar al servicio la información financiera del usuario, retorna el código de éxito de la solicitud
     *
     * *Function that sends to the service user's financial information, returns solicitation success code*
     *
     * @type {function}
     * @returns {this.code}
     */
    PostValidateService.prototype.createFinancials = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cryptoVaultService.refreshKeyCrypto()];
                    case 1:
                        _a.sent();
                        setTimeout(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var _this = this;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.captureService.createFinancials().then(function () {
                                            try {
                                                _this.code = '200';
                                            }
                                            catch (error) {
                                                _this.code = '500';
                                            }
                                        }, function () {
                                            return _this.code = '500';
                                        })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }, 1000);
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    /* istanbul ignore next */
    /**
     * Función para envíar al servicio la información de operaciones extrangeras del usuario, retorna el código de éxito de la solicitud
     *
     * *Function that sends to the service user information of foreign operation, return solicitation success code*
     *
     * @type {function}
     * @returns {this.code}
     */
    PostValidateService.prototype.foreignOperations = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, operationCurrencyList, foreignProductsInfo, foreignProductsSelected, foreignCurrencyModel, body, foreign, exports_operations, foreign_currency_investments, foreign_currency_other_ops, foreign_product_amount, foreign_currency_payments, general_foreign_ops, imports_operations, titular_products_foreign_cur, foreign_product_city, foreign_product_company, foreign_product_country, foreign_product_is_credit, foreign_product_number, foreign_currency_alternative_ops, foreign_product_type, country, foreign_ops, solicitationId;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.abreCuentasService.getAbreCuentasModel(), operationCurrencyList = _a.operationCurrencyList, foreignProductsInfo = _a.foreignProductsInfo, foreignProductsSelected = _a.foreignProductsSelected, foreignCurrencyModel = _a.foreignCurrencyModel;
                        body = {
                            general_foreign_ops: false,
                            foreign_currency_investments: false,
                            foreign_currency_payments: false,
                            foreign_currency_other_ops: false,
                            imports_operations: false,
                            exports_operations: false,
                            titular_products_foreign_cur: false,
                            foreign_currency_alternative_ops: false,
                            foreign_product_is_credit: false,
                            foreign_product_amount: {
                                currency: '',
                                amount: 0,
                            },
                        };
                        if (this.abreCuentasService.getPostlogin()) {
                            try {
                                foreign = this.abreCuentasService.getCustomerData().foreign;
                                exports_operations = foreign.exports_operations, foreign_currency_investments = foreign.foreign_currency_investments, foreign_currency_other_ops = foreign.foreign_currency_other_ops, foreign_product_amount = foreign.foreign_product_amount, foreign_currency_payments = foreign.foreign_currency_payments, general_foreign_ops = foreign.general_foreign_ops, imports_operations = foreign.imports_operations, titular_products_foreign_cur = foreign.titular_products_foreign_cur, foreign_product_city = foreign.foreign_product_city, foreign_product_company = foreign.foreign_product_company, foreign_product_country = foreign.foreign_product_country, foreign_product_is_credit = foreign.foreign_product_is_credit, foreign_product_number = foreign.foreign_product_number, foreign_currency_alternative_ops = foreign.foreign_currency_alternative_ops, foreign_product_type = foreign.foreign_product_type;
                                if (foreign) {
                                    if (general_foreign_ops === 'Si' || general_foreign_ops === 'SI') {
                                        body = tslib_1.__assign({}, body, { general_foreign_ops: this.helperService.mapBooleanData(general_foreign_ops), foreign_currency_alternative_ops: this.helperService.mapBooleanData(foreign_currency_alternative_ops), foreign_currency_investments: this.helperService.mapBooleanData(foreign_currency_investments), foreign_currency_payments: this.helperService.mapBooleanData(foreign_currency_payments), foreign_currency_other_ops: this.helperService.mapBooleanData(foreign_currency_other_ops), imports_operations: this.helperService.mapBooleanData(imports_operations), exports_operations: this.helperService.mapBooleanData(exports_operations), foreign_product_is_credit: this.helperService.mapBooleanData(foreign_product_is_credit) });
                                    }
                                    if (titular_products_foreign_cur === 'Si' || titular_products_foreign_cur === 'SI') {
                                        country = this.abreCuentasService.filterCountryListxName(foreign_product_country);
                                        body = tslib_1.__assign({}, body, { titular_products_foreign_cur: this.helperService.mapBooleanData(titular_products_foreign_cur), general_foreign_ops: this.helperService.mapBooleanData(titular_products_foreign_cur), foreign_product_type: foreign_currency_alternative_ops, foreign_product_number: foreign_product_number,
                                            foreign_product_city: foreign_product_city, foreign_product_country: country.country_code, foreign_product_amount: foreign_product_amount,
                                            foreign_product_company: foreign_product_company });
                                    }
                                }
                            }
                            catch (error) {
                                console.log(error);
                            }
                        }
                        else {
                            if (foreignCurrencyModel && foreignCurrencyModel.elementId && foreignCurrencyModel.elementId !== 2) {
                                foreign_ops = {
                                    imports: operationCurrencyList.find(function (data) { return data.id === 771; }),
                                    exports: operationCurrencyList.find(function (data) { return data.id === 772; }),
                                    investments: operationCurrencyList.find(function (data) { return data.id === 774; }),
                                    credit: operationCurrencyList.find(function (data) { return data.id === 776; }),
                                    other: operationCurrencyList.find(function (data) { return data.id === 781; }),
                                    payments: operationCurrencyList.find(function (data) { return data.id === 780; }),
                                };
                                body = tslib_1.__assign({}, body, { general_foreign_ops: foreignCurrencyModel.checked
                                        ? foreignCurrencyModel.checked
                                        : false, foreign_currency_alternative_ops: foreignCurrencyModel
                                        ? foreignCurrencyModel.checked
                                        : false, foreign_currency_investments: foreign_ops.investments
                                        ? foreign_ops.investments.checked
                                        : false, foreign_currency_payments: foreign_ops.payments
                                        ? foreign_ops.payments.checked
                                        : false, foreign_currency_other_ops: foreign_ops.other
                                        ? foreign_ops.other.checked
                                        : false, imports_operations: foreign_ops.imports
                                        ? foreign_ops.imports.checked
                                        : false, exports_operations: foreign_ops.exports
                                        ? foreign_ops.exports.checked
                                        : false, foreign_product_is_credit: foreign_ops.credit
                                        ? foreign_ops.credit.checked
                                        : false });
                            }
                            if (foreignProductsSelected && foreignProductsSelected.elementId && foreignProductsSelected.elementId !== 2) {
                                body = tslib_1.__assign({}, body, { titular_products_foreign_cur: foreignProductsSelected.checked, general_foreign_ops: foreignCurrencyModel.elementId !== 2 && foreignCurrencyModel.checked
                                        ? foreignCurrencyModel.checked
                                        : false, foreign_product_type: foreignProductsInfo.product_type, foreign_product_number: foreignProductsInfo.product_id, foreign_product_city: '', foreign_product_country: foreignProductsInfo.country.country_code, foreign_product_amount: {
                                        currency: foreignProductsInfo.currency
                                            .normalize('NFD')
                                            .replace(/[\u0300-\u0301]/g, ''),
                                        amount: +foreignProductsInfo.amount,
                                        decimals: 0,
                                    }, foreign_product_company: foreignProductsInfo.entity_name });
                            }
                        }
                        if (!this.validationHelperService.isPassiveProduct()) {
                            body = [
                                tslib_1.__assign({ document: {
                                        type: this.abreCuentasService.getDocumentInfo().document_type,
                                        number: this.abreCuentasService.getDocumentInfo().document_number,
                                    } }, body),
                            ];
                        }
                        solicitationId = this.abreCuentasService.getSolicitationId();
                        return [4 /*yield*/, this.requestService
                                .foreignOperationsCase({ data: body }, solicitationId)
                                .then(function () {
                                try {
                                    _this.code = '200';
                                }
                                catch (error) {
                                    _this.code = '500';
                                }
                            }, function () {
                                return _this.code = '500';
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    /* istanbul ignore next */
    /**
     * Función para crear el producto seleccionado por el usuario, retorna el código de éxito de la solicitud
     *
     * *Function that creates the product selected by the user, return solicitation success code*
     *
     * @type {function}
     * @returns {this.code}
     */
    PostValidateService.prototype.createProducts = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var self, productCode, prospect, postLogin, productType, rate, productsmulti, products, taxRateValue, body, ProductsList, solicitationId;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('Create Product >>>>> AbreCuentasService >>> ', this.abreCuentasService);
                        self = this.abreCuentasService.getAbreCuentasModel();
                        productCode = this.abreCuentasService.getproductSelected();
                        prospect = this.abreCuentasService.getProspectResponse();
                        postLogin = this.abreCuentasService.getPostlogin();
                        productType = this.abreCuentasService.getproductSelected().product_type;
                        this.ProductMulti = this.parametersService.getSetting(OpEnum.LIST_MULTI);
                        rate = [{}];
                        productsmulti = this.abreCuentasService.getProductsSelects();
                        if (productType === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
                            productsmulti.find(function (find) { return find.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE; })) {
                            products = {
                                product_type: productCode.product_code,
                                product_subtype: '533',
                            };
                            console.log('Linea 432 >>>> CreditParms >>> ', self.creditParms);
                            taxRateValue = !this.firmlyApprovedService.isEmpty() &&
                                this.firmlyApprovedService.getOfferType_Channel() === 'En_firme'
                                ? self.creditParms.rateValue['rate_NA']
                                : this.abreCuentasService.getRatesOffer();
                            console.log('taxRateValue', taxRateValue);
                            rate = [taxRateValue];
                        }
                        else if (productType === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
                            products = {
                                product_type: this.abreCuentasService.getOtherSimulationData().sub_product,
                                product_subtype: this.abreCuentasService.getOtherSimulationData().code,
                            };
                        }
                        else if (productType === BUSINESS_CONST.PRODUCT_TYPE_TC) {
                            products = {
                                product_type: productCode.product_code,
                            };
                        }
                        else {
                            products = {
                                product_type: 'CRP',
                                product_subtype: prospect.client === false
                                    ? '131'
                                    : this.helperService.getProductCodeBySegmentId(self.basicModel.sub_segment_id),
                            };
                        }
                        body = {};
                        if (productType === BUSINESS_CONST.PRODUCT_TYPE_TC) {
                            switch (self.paydayProductModel.selectedProduct.elementId) {
                                case 1:
                                    this.brandProduct = BUSINESS_CONST.MASTER;
                                    break;
                                case 2:
                                    this.brandProduct = BUSINESS_CONST.VISA;
                                    break;
                                case 3:
                                    this.brandProduct = BUSINESS_CONST.VISALM;
                                    break;
                            }
                            body = {
                                brand: self.paydayProductModel.selectedProduct.elementId === 1
                                    ? BUSINESS_CONST.MASTER
                                    : BUSINESS_CONST.VISA,
                                brand_code: self.cardType.bin,
                                brand_details: this.abreCuentasService.isGrayZone()
                                    ? this.brandProduct
                                    : self.cardType.brand_details,
                                affinity: '1',
                                affinity_code: self.cardType.afinity_code,
                                invoice_cycle: self.paydayProductModel.selectedPayDay.elementId === 10 ? '3' : '1',
                                segment_code: self.cardType.part_segment_code,
                            };
                        }
                        else if (productType == BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
                            body = tslib_1.__assign({}, body, { city: this.abreCuentasService.getSimulatorModel().city });
                        }
                        console.log('body', body);
                        if (!this.firmlyApprovedService.isEmpty() &&
                            this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
                            ProductsList = this.firmlyApprovedService.getDetailProductsMulti();
                        }
                        else {
                            switch (productType) {
                                case BUSINESS_CONST.MULTI:
                                    ProductsList = self.pcoModel.granted_product_multi;
                                    break;
                                default:
                                    ProductsList =
                                        self.pcoModel.granted_product_multi.length > 0
                                            ? self.pcoModel.granted_product_multi
                                            : [self.pcoModel.granted_product];
                                    break;
                            }
                        }
                        body = this.body(body, self, ProductsList, productType, rate, postLogin, prospect);
                        console.log('--------PRODUCTS------------');
                        console.warn('Body del producto a enviar ---->>> \n', body);
                        solicitationId = this.abreCuentasService.getSolicitationId();
                        return [4 /*yield*/, this.requestService
                                .createProduct({ data: body }, solicitationId)
                                .then(function () {
                                try {
                                    _this.code = '200';
                                }
                                catch (error) {
                                    console.log('Error creando producto >>>> ', error);
                                    _this.code = '500';
                                }
                            }, function () {
                                return _this.code = '500';
                            })
                                .catch(function (error) {
                                console.log('Error creando producto >>>> ', error);
                                _this.code = '500';
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    /* istanbul ignore next */
    /**
     * Función de desempeño de la solicitud
     *
     * *Function perform solicitation*
     *
     * @type {function}
     * @returns {this.code}
     */
    PostValidateService.prototype.performSolicitation = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var body, solicitationId;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = {
                            data: [
                                {
                                    solicitation_type: 'tskAvanzarProcesoDigital',
                                },
                            ],
                        };
                        solicitationId = this.abreCuentasService.getSolicitationId();
                        return [4 /*yield*/, this.requestService
                                .performSolicitation(body, solicitationId)
                                .then(function () {
                                try {
                                    _this.code = '200';
                                }
                                catch (error) {
                                    _this.code = '500';
                                }
                            })];
                    case 1:
                        _a.sent();
                        // this.productLoaderService.hide();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    /* istanbul ignore next */
    /**
     * Función para obtener el caso
     *
     * *Function that gets the case*
     *
     * @type {function}
     * @returns {this.code}
     */
    PostValidateService.prototype.getCase = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var solicitationId, productCode;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.productLoaderService.show(this.copyService.copies.show_create_product, this.parametersService.getSetting(OpEnum.GET_CASE_TIME_OUTS)['first-timeout'] * 1000);
                        if (!(this.callTimeOut === 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.abreCuentasService.sleep(this.parametersService.getSetting(OpEnum.GET_CASE_TIME_OUTS)['first-timeout'] * 1000)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        setTimeout(function () {
                            _this.cryptoVaultService.refreshKeyCrypto();
                        }, (this.parametersService.getSetting(OpEnum.GET_CASE_TIME_OUTS)['first-timeout'] * 1000) / 2);
                        solicitationId = this.abreCuentasService.getSolicitationId();
                        productCode = this.abreCuentasService.getproductSelected().product_code;
                        return [4 /*yield*/, this.requestService
                                .getCaseSolicitationInfo(solicitationId, productCode)
                                .then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var resp, card, documentNumber, _a, productDetail, detailRevolvingCredit, error_1;
                                return tslib_1.__generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            this.getCaseCount += 1;
                                            _b.label = 1;
                                        case 1:
                                            _b.trys.push([1, 14, , 15]);
                                            if (!(response.status === 200)) return [3 /*break*/, 12];
                                            resp = response.body.data;
                                            card = resp;
                                            documentNumber = this.abreCuentasService.getDocumentInfo().document_number;
                                            this.abreCuentasService.setProductCard(card);
                                            _a = card.solicitation_status.status_code;
                                            switch (_a) {
                                                case '03': return [3 /*break*/, 2];
                                                case '01': return [3 /*break*/, 4];
                                                case '02': return [3 /*break*/, 4];
                                                case '00': return [3 /*break*/, 5];
                                                case '04': return [3 /*break*/, 6];
                                                case '07': return [3 /*break*/, 7];
                                                case '05': return [3 /*break*/, 8];
                                                case '06': return [3 /*break*/, 9];
                                            }
                                            return [3 /*break*/, 10];
                                        case 2:
                                            if (this.abreCuentasService.isGrayZone()) {
                                                this.code = '201';
                                                return [3 /*break*/, 11];
                                            }
                                            return [4 /*yield*/, this.abreCuentasService.sleep(this.parametersService.getSetting(OpEnum.GET_CASE_TIME_OUTS)['second-timeout'] * 1000)];
                                        case 3:
                                            _b.sent();
                                            if (this.getCaseCount === 2) {
                                                this.code = 'secondCall';
                                            }
                                            else {
                                                this.callTimeOut++;
                                                return [2 /*return*/, this.getCase()];
                                            }
                                            return [3 /*break*/, 11];
                                        case 4:
                                            this.code = '127';
                                            return [3 /*break*/, 11];
                                        case 5:
                                            if (this.abreCuentasService.getproductSelected().name ===
                                                BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
                                                this.abreCuentasService.getproductSelected().name ===
                                                    BUSINESS_CONST.PRODUCT_TYPE_FREE) {
                                                productDetail = new DetailAccountModel();
                                                detailRevolvingCredit = new DetailRevolvingCreditModel();
                                                productDetail.account_number =
                                                    resp.destination_account.account_id;
                                                productDetail.create_date_account = resp.transaction_date;
                                                detailRevolvingCredit.available_amount =
                                                    resp.available_amount;
                                                detailRevolvingCredit.product_id = resp.product_id;
                                                this.abreCuentasService.setDetailAccountCreation(productDetail);
                                                this.abreCuentasService.setDetailRevolvingCreditCreation(detailRevolvingCredit);
                                            }
                                            this.code = '200';
                                            return [3 /*break*/, 11];
                                        case 6:
                                            this.code = '200';
                                            return [3 /*break*/, 11];
                                        case 7:
                                            this.code = '129';
                                            return [3 /*break*/, 11];
                                        case 8:
                                            this.code = '130';
                                            return [3 /*break*/, 11];
                                        case 9:
                                            this.code = '201';
                                            return [3 /*break*/, 11];
                                        case 10:
                                            this.code = '127';
                                            return [3 /*break*/, 11];
                                        case 11: return [3 /*break*/, 13];
                                        case 12:
                                            this.code = '127';
                                            _b.label = 13;
                                        case 13: return [3 /*break*/, 15];
                                        case 14:
                                            error_1 = _b.sent();
                                            this.code = '127';
                                            return [3 /*break*/, 15];
                                        case 15: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 3:
                        _a.sent();
                        this.productLoaderService.hide();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    /* istanbul ignore next */
    /**
     * Función para actualizar la configuración del caso de la cuenta
     *
     * *Function that updates case account config*
     *
     * @type {function}
     * @returns {this.code}
     */
    PostValidateService.prototype.updateCaseAccountConfig = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var body;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = {
                            solicitation_id: this.abreCuentasService.getSolicitationId(),
                            card_delivery_type: this.abreCuentasService.getReceiveCard(),
                            is_benefit_exempt: null,
                        };
                        if (this.abreCuentasService.getproductSelected().product_type ===
                            BUSINESS_CONST.PRODUCT_TYPE_PAYROLL) {
                            body = tslib_1.__assign({}, body, { is_benefit_exempt: this.abreCuentasService.getAgreementSelected().transaction_type });
                        }
                        if (this.abreCuentasService.viewOptionMultiProduct &&
                            this.abreCuentasService.getStatusCreate()) {
                            body = tslib_1.__assign({}, body, { account_type: 'AHO', account_subtype: '533', campaign_id: '' });
                        }
                        return [4 /*yield*/, this.requestService
                                .updateCaseAccountConfig({ data: body })
                                .then(function () {
                                try {
                                    _this.code = '200';
                                }
                                catch (error) {
                                    _this.code = '500';
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    PostValidateService.prototype.body = function (tdc, self, ProductsList, productType, rate, postLogin, prospect) {
        var e_1, _a;
        var _this = this;
        console.warn('----------------- Body Post-Validate ---------------------------');
        console.log('Self: ', self);
        var allies = this.channel.getChannelId() === '163';
        var itemsSelected;
        if (allies) {
            itemsSelected = [this.abreCuentasService.getproductSelected()];
        }
        else {
            itemsSelected = this.abreCuentasService.getProductsSelects();
        }
        var indexTc = 1;
        var virtualCardFranchise = self.virtualCardFranchiseModel !== undefined &&
            self.virtualCardFranchiseModel.selectedFranchise !== undefined
            ? self.virtualCardFranchiseModel.selectedFranchise
            : { label: '' };
        var body = [];
        var brandMap = {
            1: BUSINESS_CONST.MASTER,
            2: BUSINESS_CONST.VISA,
            3: BUSINESS_CONST.VISALM,
        };
        if (ProductsList[0].product_type !== BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
            if (!allies) {
                itemsSelected = itemsSelected.sort(function (product1, product2) {
                    return Number(product1.prioritizeForClient) -
                        Number(product2.prioritizeForClient);
                });
            }
            var products = [];
            var filterProductsTC = [];
            var _loop_1 = function (item) {
                var filterProductsByType = ProductsList.filter(function (prod) { return prod.product_type === item.product_type; });
                products.push(filterProductsByType[0]);
                if (item.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC &&
                    filterProductsByType.length > 1) {
                    filterProductsTC = filterProductsByType.slice(1, filterProductsByType.length);
                }
            };
            try {
                for (var itemsSelected_1 = tslib_1.__values(itemsSelected), itemsSelected_1_1 = itemsSelected_1.next(); !itemsSelected_1_1.done; itemsSelected_1_1 = itemsSelected_1.next()) {
                    var item = itemsSelected_1_1.value;
                    _loop_1(item);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (itemsSelected_1_1 && !itemsSelected_1_1.done && (_a = itemsSelected_1.return)) _a.call(itemsSelected_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (filterProductsTC.length > 0) {
                products = products.concat(filterProductsTC);
            }
            ProductsList = products;
        }
        ProductsList.forEach(function (product, index) {
            console.log('index->', index);
            console.log('Product: ', product);
            var cardType = product.brand && self.cardTypes[product.brand]
                ? self.cardTypes[product.brand]
                : self.cardType;
            console.warn('CardTypes: ', cardType, '\nProduct: ', product);
            console.warn('VirtualCardFranchise: ', virtualCardFranchise);
            var virtualCardFlag = (product.brand === undefined &&
                product.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) ||
                (product.brand && product.brand === virtualCardFranchise.label);
            var bodyProduct = tslib_1.__assign({}, tdc, { refund_information: _this.refundInfoByProduct(product), offer_id: _this.firmlyApprovedService.getOfferId_Channel() !== ''
                    ? _this.firmlyApprovedService.getOfferId_Channel()
                    : '', campaign_id: cardType.campaign_code !== undefined ? cardType.campaign_code : 0, client_name: (self.documentModel.firstname || '') + " " + (self.documentModel.middlename
                    ? self.documentModel.middlename + ' '
                    : '') + self.documentModel.primary_lastname + " " + self.documentModel.second_lastname, available_amount: [_this.validAmountFirmlyApproved(product)], brand: product.product_type !== BUSINESS_CONST.PRODUCT_TYPE_TC
                    ? ''
                    : self.paydayProductModel.selectedProduct.elementId === 1
                        ? BUSINESS_CONST.MASTER
                        : BUSINESS_CONST.VISA, brand_code: product.product_type !== BUSINESS_CONST.PRODUCT_TYPE_TC
                    ? ''
                    : cardType.bin, brand_details: product.product_type !== BUSINESS_CONST.PRODUCT_TYPE_TC
                    ? ''
                    : _this.abreCuentasService.isGrayZone()
                        ? brandMap[self.paydayProductModel.selectedProduct.elementId]
                        : cardType.brand_details, affinity: '1', affinity_code: product.product_type !== BUSINESS_CONST.PRODUCT_TYPE_TC
                    ? ''
                    : cardType.afinity_code, invoice_cycle: product.product_type !== BUSINESS_CONST.PRODUCT_TYPE_TC
                    ? ''
                    : self.paydayProductModel.selectedPayDay.elementId === 10
                        ? '3'
                        : '1', segment_code: product.product_type !== BUSINESS_CONST.PRODUCT_TYPE_TC
                    ? ''
                    : cardType.part_segment_code, card_virtual_flag: virtualCardFlag, billing_date: '2022-04-01T00:00:00', rate: _this.validRateFirmlyApproved(product), term: {
                    period: _this.abreCuentasService.getAbreCuentasModel().creditParms
                        .maxPeriodValue,
                    frecuency: 'MM',
                }, blocked: false, is_beneficiary: false, product: {
                    product_id: product.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC
                        ? '' + indexTc++
                        : '',
                    product_type: product.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING
                        ? _this.abreCuentasService.getOtherSimulationData().sub_product
                        : _this.productCodeSelected(product.product_type),
                    product_subtype: product.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING
                        ? _this.abreCuentasService.getOtherSimulationData().code
                        : _this.productCodeSelected(product.product_type) === 'ORD'
                            ? '533'
                            : _this.productCodeSelected(product.product_type) === 'TCR'
                                ? ''
                                : _this.productCodeSelected(product.product_type) === BUSINESS_CONST.PRODUCT_TYPE_LIB
                                    ? '371'
                                    : prospect.client === false
                                        ? '131'
                                        : _this.helperService.getProductCodeBySegmentId(self.basicModel.sub_segment_id),
                }, priority: index + 1, installments_quantity: _this.productCodeSelected(product.product_type) === BUSINESS_CONST.PRODUCT_CODE_ORD
                    || _this.productCodeSelected(product.product_type) === BUSINESS_CONST.PRODUCT_TYPE_LIB
                    ? _this.abreCuentasService.getAbreCuentasModel().creditParms
                        .maxPeriodValue
                    : '0' });
            if (product.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
                bodyProduct = _this.fieldLoan(bodyProduct);
            }
            console.log('bodyProduct ajustado: ', bodyProduct);
            if (product.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
                product.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
                product.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
                var createProduct = product.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ? _this.abreCuentasService.getAssociateRevolving() :
                    _this.abreCuentasService.getcreateProductSelected();
                if (postLogin && createProduct !== undefined) {
                    bodyProduct.destination_account = {
                        account_id: createProduct.account_id,
                        account_type: createProduct.account_type,
                        account_subtype: createProduct.account_subtype,
                    };
                    bodyProduct.refund_information = _this.refundInfo(product, createProduct);
                }
                else if (!_this.firmlyApprovedService.isEmpty() && _this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
                    console.log('Refund: ', bodyProduct);
                    bodyProduct.refund_information[0].refund_method = 'AC';
                    bodyProduct.refund_information[0].branch_id = _this.abreCuentasService.getAgencySelected()
                        ? _this.abreCuentasService.getAgencySelected().agency_code
                        : '';
                    bodyProduct.refund_information[0].amount = _this.validAmountFirmlyApproved(product);
                    console.log('Refund modificado: ', bodyProduct);
                }
                if (product.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
                    product.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
                    (bodyProduct.installments_quantity = Number(self.creditParms.maxPeriodValue)),
                        (bodyProduct['billing_date'] =
                            _this.abreCuentasService.getPAyDay(true)),
                        (bodyProduct.rate = _this.validRateFirmlyApproved(product, rate));
                    bodyProduct.origin_amount = [
                        {
                            currency: BANK_INFO_CONST.CURRENCY,
                            amount: self.creditParms.maxAmountValue.toString(),
                            decimals: 0,
                        },
                    ];
                    bodyProduct.term = {
                        period: _this.abreCuentasService.getAbreCuentasModel().creditParms
                            .maxPeriodValue,
                        frecuency: 'MM',
                    };
                    if (!_this.firmlyApprovedService.isEmpty() &&
                        _this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
                        bodyProduct.rates = _this.formatRateFirmlyApproved(_this.abreCuentasService.getAbreCuentasModel().creditParms.rateValue);
                    }
                }
            }
            // purchase_option solo en leaseback LEA 07, compra cartera LEA o HIP 03 55, vivienda LEA o HIP 52 01
            if (productType === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
                bodyProduct.origin_amount = [
                    {
                        currency: BANK_INFO_CONST.CURRENCY,
                        amount: self.creditParms.maxAmountValue.toString(),
                        decimals: 0,
                    },
                ];
                bodyProduct.installments_quantity = Number(self.creditParms.maxPeriodValue);
                bodyProduct.assisted_housing_flag =
                    self.simulatorModel.assisted_housing_flag;
                bodyProduct.new_housing_flag = self.simulatorModel.new_housing_flag;
                bodyProduct.financing_type = '1';
                if (self.otherSimulationData.code === '01' ||
                    self.otherSimulationData.code === '52' ||
                    self.otherSimulationData.code === '55' ||
                    self.otherSimulationData.code === '03' ||
                    self.otherSimulationData.code === '07') {
                    bodyProduct.purchase_option = self.simulatorModel.purchase_option;
                }
                bodyProduct.own_project_flag = self.simulatorModel.own_project_flag;
                bodyProduct.capital_amount = [
                    {
                        currency: self.simulatorModel.property_amount.currency,
                        amount: self.simulatorModel.property_amount.amount,
                        decimals: self.simulatorModel.property_amount.decimal,
                    },
                ];
                bodyProduct.term = {
                    period: _this.abreCuentasService.getAbreCuentasModel().creditParms
                        .maxPeriodValue,
                    frecuency: 'MM',
                };
                if (self.otherSimulationData.code === '03' ||
                    self.otherSimulationData.code === '55') {
                    bodyProduct.liabilities = [
                        {
                            liability_id: self.simulatorModel.libialities.liability_id,
                            bank_name: self.simulatorModel.libialities.liability_id,
                            bank_id: self.simulatorModel.libialities.bank_name,
                            payoff_amount: {
                                currency: self.simulatorModel.available_amount.currency,
                                amount: self.simulatorModel.available_amount.amount,
                                decimals: self.simulatorModel.available_amount.decimals,
                            },
                            monthly_fee_amount: self.simulatorModel.fee,
                        },
                    ];
                }
                bodyProduct.leasing_contract = self.simulatorModel.leasing_contract;
            }
            console.warn('Body ajustado ---->\n', bodyProduct);
            body.push(bodyProduct);
            if (bodyProduct.rates) {
                _this.requestService.setRates(bodyProduct.rates);
            }
        });
        console.warn('----------------- Fin Body Post-Validate ---------------------------');
        return body;
    };
    PostValidateService.prototype.refundInfo = function (product, createProduct) {
        if (this.abreCuentasService.haveLoan && product.product_type !== BUSINESS_CONST.PRODUCT_TYPE_REVOLVING) {
            return this.loanRefund(product);
        }
        else {
            return [{
                    refund_method: 'AC',
                    account: {
                        account_id: createProduct.account_id,
                        account_type: createProduct.account_type,
                        account_subtype: createProduct.account_subtype,
                    },
                    branch_id: this.abreCuentasService.getAgencySelected()
                        ? this.abreCuentasService.getAgencySelected().agency_code
                        : '',
                    amount: this.validAmountFirmlyApproved(product),
                }];
        }
    };
    PostValidateService.prototype.fieldLoan = function (body) {
        var loanSelected = this.abreCuentasService.getRequestLoanSelected().elementId;
        if (this.abreCuentasService.haveLoan) {
            var destinity = {
                destinity: loanSelected,
            };
            body = Object.assign(body, destinity);
            var fee_amount = {
                fee_amount: {
                    currency: BANK_INFO_CONST.CURRENCY,
                    amount: this.abreCuentasService.getSaveValueInputAmount() ? this.abreCuentasService.getSaveValueInputAmount() : '0',
                    decimals: 0,
                },
            };
            body = Object.assign(body, fee_amount);
            if (loanSelected !== '01') {
                this.infoCredit();
                var passive = {
                    liabilities: this.liabilities,
                    credit_recharge_up_information: this.creditRechargeUpInformation,
                };
                body = Object.assign(body, passive);
            }
            var destination = {
                product_destination_type: this.abreCuentasService.getProductDestinationType(),
            };
            if (body.product) {
                body.product = Object.assign(body.product, destination);
            }
        }
        return body;
    };
    PostValidateService.prototype.infoCredit = function () {
        switch (this.abreCuentasService.getRequestEntity()) {
            case 1:
                this.creditItau();
                break;
            case 2:
                this.creditOther();
                break;
            default:
                this.creditItau();
                this.creditOther();
                break;
        }
    };
    PostValidateService.prototype.creditItau = function () {
        var _this = this;
        var loans = this.abreCuentasService.getCreditList();
        loans.map(function (i) {
            _this.creditRechargeUpInformation.push({
                account_subtype: i.type,
                credit_recharge_up_id: i.number,
                payoff_amount: {
                    currency: BANK_INFO_CONST.CURRENCY,
                    amount: i.amount,
                    decimals: 0,
                },
                // toDo
                monthly_fee_amount: {
                    currency: BANK_INFO_CONST.CURRENCY,
                    amount: '',
                    decimals: 0,
                },
            });
        });
    };
    PostValidateService.prototype.creditOther = function () {
        var _this = this;
        var loansInfo = this.abreCuentasService.getFormLoan();
        loansInfo.addLoanForm.map(function (i) {
            _this.liabilities.push({
                bank_id: i.nitEntityForm,
                liability_id: i.numProductForm,
                bank_name: i.nameEntityForm,
                payoff_amount: {
                    currency: BANK_INFO_CONST.CURRENCY,
                    amount: i.valuePortfolioForm,
                    decimals: 0,
                },
                monthly_fee_amount: {
                    currency: BANK_INFO_CONST.CURRENCY,
                    amount: i.freeValueForm,
                    decimals: 0,
                },
            });
        });
    };
    PostValidateService.prototype.productCodeSelected = function (productType) {
        // tslint:disable-next-line
        var data = this.ProductMulti.find(
        // tslint:disable-next-line
        function (data) { return data.product_type === productType; });
        return data ? data.product_code : '';
    };
    PostValidateService.prototype.refundInfoByProduct = function (product) {
        if (product.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE) {
            var refund = this.abreCuentasService.getDisbursementInfo();
            console.log('Refund: ', refund);
            refund = refund.find(function (data) { return data.product_type === product.product_type; }).refund;
            refund[0].account.account_subtype = parseFloat(this.abreCuentasService.getinfoInferredIncomes().account_type);
            refund[0].account.account_type = 'AHO';
            return refund;
        }
        else if (product.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING) {
            this.abreCuentasService.setStatusCreate(true);
            if (this.abreCuentasService.haveLoan) {
                var refund = this.loanRefund(product)[0];
                refund.account.account_type = 'AHO';
                refund.account.account_subtype = parseFloat(this.abreCuentasService.getinfoInferredIncomes().account_type);
                refund.refund_method = 'AC';
                return [refund];
            }
            else {
                return [
                    {
                        refund_method: 'AC',
                        account: {
                            account_id: '',
                            account_type: 'AHO',
                            account_subtype: parseFloat(this.abreCuentasService.getinfoInferredIncomes().account_type),
                        },
                        branch_id: this.abreCuentasService.getAgencySelected()
                            ? this.abreCuentasService.getAgencySelected().agency_code
                            : '',
                        amount: this.validAmountFirmlyApproved(product),
                    },
                ];
            }
        }
        else if (product.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
            return this.loanRefund(product);
        }
        else {
            return [];
        }
    };
    PostValidateService.prototype.loanRefund = function (product) {
        var refund = this.abreCuentasService.getDisbursementInfo();
        refund = refund.find(function (data) { return data.product_type === product.product_type; }).refund;
        return refund;
    };
    /**
     * Función que permite formatear las TASAS según sea el caso,
     * si es un Aprobado en Firme o no.
     * @param product
     * @param rate
     * @returns
     */
    PostValidateService.prototype.validRateFirmlyApproved = function (product, rate) {
        var rate_prod = [{}];
        var exp_reg = /[.,%]/g;
        if (!this.firmlyApprovedService.isEmpty() &&
            this.firmlyApprovedService.getOfferType_Channel() === 'En_firme' &&
            product.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE) {
            var rate_firmlyApproved = this.abreCuentasService.getAbreCuentasModel().creditParms.rateValue;
            rate_prod = [
                {
                    decimals: this.numberHelper.countDecimalDigits(rate_firmlyApproved.rate_NA.replace('%', '').replace(',', '.')),
                    value: parseFloat(rate_firmlyApproved.rate_NA.replace(exp_reg, '')),
                },
            ];
        }
        else if (product.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
            this.abreCuentasService.haveLoan) {
            rate_prod = this.productRate(product, rate);
        }
        else if (product.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
            rate_prod = [this.abreCuentasService.getRatesOffer()];
        }
        else {
            rate_prod = [
                {
                    value: 95,
                    decimals: 1,
                },
            ];
        }
        return rate_prod;
    };
    PostValidateService.prototype.productRate = function (product, rate) {
        var exp_reg = /[. ()]/g;
        var rateLoan;
        if (this.abreCuentasService.haveLoan) {
            var tasa = this.abreCuentasService.getRatesLoan();
            tasa = tasa.replace(exp_reg, '').split('%')[1];
            rateLoan = [{
                    value: Number(tasa),
                    decimals: 3,
                }];
        }
        rate = product.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ? rate : rateLoan;
        return rate;
    };
    /**
     * Función que permite formatear las 3 tasas del Crédito Personal del
     * Aprobado en Firme
     * @param rates
     */
    PostValidateService.prototype.formatRateFirmlyApproved = function (rates) {
        var exp_reg = /[.,%]/g;
        return [
            {
                decimals: this.numberHelper.countDecimalDigits(rates.rate_EA.replace('%', '').replace(',', '.')),
                type: 'EA',
                value: parseFloat(rates.rate_EA.replace(exp_reg, '')),
            },
            {
                decimals: this.numberHelper.countDecimalDigits(rates.rate_MV.replace('%', '').replace(',', '.')),
                type: 'MV',
                value: parseFloat(rates.rate_MV.replace(exp_reg, '')),
            },
            {
                decimals: this.numberHelper.countDecimalDigits(rates.rate_NA.replace('%', '').replace(',', '.')),
                type: 'NA',
                value: parseFloat(rates.rate_NA.replace(exp_reg, '')),
            },
        ];
    };
    /**
     * Función que permite validar si el producto es un Aprobado en Firme
     * para formatear el campo amount.
     * @param product
     * @returns
     */
    PostValidateService.prototype.validAmountFirmlyApproved = function (product) {
        var amount_data = {};
        console.log(product);
        amount_data = {
            currency: product.limit_amount === null ? '' : product.limit_amount.currency,
            amount: product.limit_amount === null
                ? ''
                : parseInt(this.validAmount(product.limit_amount.amount), 10),
            decimals: 0,
        };
        return amount_data;
    };
    PostValidateService.prototype.validAmount = function (amount) {
        console.log('amount', amount);
        amount = amount.toString();
        amount = amount.includes('.') ? amount.replace(/[^0-9|-]/g, '') : amount;
        return amount.toString();
    };
    PostValidateService.prototype.getChannelNotification = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.solicitationIdV = this.abreCuentasService.getSolicitationId();
                        return [4 /*yield*/, this.requestService
                                .getChannelNotification(this.solicitationIdV)
                                .then(function (res) {
                                var dataPCO = JSON.parse(_this.cipherService.decrypt(res.data.message));
                                _this.abreCuentasService.setChannelNotificationData(dataPCO);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return PostValidateService;
}());
export { PostValidateService };
